import { type Search } from '@jsmdg/algolia-helpers';
import { RecommendationType } from './enums/recommendationType';
import { SortingField, SortingOrder } from './enums/sorting';

const DEFAULT_PAGINATION_SIZE = 12;
const DEFAULT_PAGINATION_OFFSET = 0;

const DEFAULT_SEARCH_CONFIG: Search = {
    pagination: {
        offset: DEFAULT_PAGINATION_OFFSET,
        size: DEFAULT_PAGINATION_SIZE,
        currentPage: 1,
    },
    sorting: {
        field: SortingField.SalesRank,
        order: SortingOrder.Desc,
    },
};

const searchConfig: Partial<Record<RecommendationType, Search>> = {
    [RecommendationType.BestSeller]: DEFAULT_SEARCH_CONFIG,
    [RecommendationType.Category]: DEFAULT_SEARCH_CONFIG,
    [RecommendationType.ProductCategory]: DEFAULT_SEARCH_CONFIG,
    [RecommendationType.LastSeenProducts]: DEFAULT_SEARCH_CONFIG,
    [RecommendationType.RelatedProducts]: DEFAULT_SEARCH_CONFIG,
};

export { DEFAULT_PAGINATION_OFFSET, DEFAULT_PAGINATION_SIZE, searchConfig };
